// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1uiGE","selects":"Documents_selects__3ab06"};